import NotFound from "@/modules/Auth/pages/NotFoundPage"
import { MembroDataType } from "@/types/membros"

export const GestaoAppRoute = ({ children }: { children: JSX.Element }) => {
  const storedUser = localStorage.getItem("user")
  const user: MembroDataType | null = storedUser ? JSON.parse(storedUser) : null

  if (!user?.gestaoApp) {
    return <NotFound />
  }

  return children
}
